import { useState, useEffect } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useAuth } from "@/context/AuthContext";
import { Skeleton } from "@/components/ui/skeleton";

export const OrganizationSelect = ({ value, onChange, preselect }) => {
    const [organizations, setOrganizations] = useState([]);
    const [loading, setLoading] = useState(true);
    const { axiosInstance } = useAuth();

    useEffect(() => {
        const fetchOrganizations = async () => {
            try {
                const response = await axiosInstance.get('/organizations');
                setOrganizations(response.data);
                if (preselect && !value && response.data.length > 0) {
                    const firstOrg = response.data[0];
                    onChange(firstOrg.id, firstOrg.name);
                }
            } catch (error) {
                console.error('Error fetching organizations:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchOrganizations();
    }, [value, onChange, preselect, axiosInstance]);

    const handleChange = (selectedId) => {
        const selectedOrg = organizations.find(org => org.id === selectedId);
        onChange(selectedId, selectedOrg?.name);
    };

    if (loading) {
        return <Skeleton className="h-10 w-full" />;
    }

    return (
        <Select value={value} onValueChange={handleChange}>
            <SelectTrigger>
                <SelectValue placeholder="Select an organization" />
            </SelectTrigger>
            <SelectContent>
                {organizations.map((org) => (
                    <SelectItem key={org.id} value={org.id}>
                        {org.name}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    );
}; 